













import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStaticsMenu, AcgnStatisticDetailNor } from '@/components';

@Component({
  components: {
    AcgnStaticsMenu,
    AcgnStatisticDetailNor
  },
  mixins: [RenderMenuMixin]
})

/**
 * 项目数据 -（数据明细-创作方）
 */
export default class StatisticComicStaffNorDetail extends Vue {

  private comicId: number; // 漫画id
  private userId: number | null = null; // 用户id

  private created() {
    const { id, userid } = this.$route.params;
    this.comicId = parseInt(id, 10);
    if (userid) {
      this.userId = parseInt(userid, 10);
    }
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="comic" comicId={this.comicId}></acgn-statics-menu>
    );
  }
}
